import ApplicationController from '../application_controller'

export default class extends ApplicationController {
  static targets = [
    'yearlyAgreementPrice',
    'monthlyAgreementPrice',
  ]

  onAgreementChange({ detail: agreement }) {
    if(agreement === 'yearly') {
      this.switchToYearlyAgreement()
    } else {
      this.switchToMonthlyAgreement()
    }
  }

  switchToYearlyAgreement() {
    this.monthlyAgreementPriceTargets.forEach(this.hide)

    this.yearlyAgreementPriceTargets.forEach(element => {
      element.classList.remove('hidden')
    })
  }

  switchToMonthlyAgreement() {
    this.yearlyAgreementPriceTargets.forEach(this.hide)

    this.monthlyAgreementPriceTargets.forEach(element => {
      element.classList.remove('hidden')
    })
  }
}
